// src/main.jsx
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

// Error tracking (optional)
if (import.meta.env.PROD) {
  // Initialize Sentry or other error tracking
  // Sentry.init({ dsn: import.meta.env.VITE_SENTRY_DSN });
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);